"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyGetMeQuery = exports.useGetMeQuery = exports.useRefreshMutation = exports.useLogoutMutation = exports.useLoginMutation = exports.authApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.authApi = (0, react_1.createApi)({
    reducerPath: "authApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["auth"],
    endpoints: function (builder) { return ({
        login: builder.mutation({
            query: function (credentials) { return ({
                url: "/v1/auth/login",
                method: "POST",
                body: credentials,
            }); },
            invalidatesTags: ["auth"],
        }),
        logout: builder.mutation({
            query: function () { return ({
                url: "/v1/auth/logout",
                method: "POST",
            }); },
            invalidatesTags: ["auth"],
        }),
        refresh: builder.mutation({
            query: function () { return ({
                url: "/v1/auth/refresh",
                method: "POST",
            }); },
        }),
        getMe: builder.query({
            query: function () { return "/v1/auth/me"; },
            providesTags: ["auth"],
        }),
    }); },
});
exports.useLoginMutation = exports.authApi.useLoginMutation, exports.useLogoutMutation = exports.authApi.useLogoutMutation, exports.useRefreshMutation = exports.authApi.useRefreshMutation, exports.useGetMeQuery = exports.authApi.useGetMeQuery, exports.useLazyGetMeQuery = exports.authApi.useLazyGetMeQuery;
